import { render, staticRenderFns } from "./properties-editor.vue?vue&type=template&id=f8cea40c&scoped=true&"
import script from "./properties-editor.vue?vue&type=script&lang=js&"
export * from "./properties-editor.vue?vue&type=script&lang=js&"
import style0 from "./properties-editor.vue?vue&type=style&index=0&id=f8cea40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cea40c",
  null
  
)

export default component.exports